var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdventureWorks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adventure-works_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.862 17.257v11.195l-13.241-1.804v-9.391h13.241zM29.862 13.412V2.217L16.621 4.02v9.391h13.241zM12.749 13.412V4.656L1.614 6.127v7.285H12.75zM12.749 17.257v8.756L1.614 24.542v-7.285H12.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "adventure-works_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v29.793H0z"
  })))));
}

export default SvgAdventureWorks;